import { NavigateFunction } from 'react-router-dom';

export enum ApplicationPaths {
    wizard = '/:combinedLoan?',
    offer = '/offer',
    cdd = '/cdd',
    sign = '/sign',
    signDetails = '/sign/details',
    uploadDocuments = '/sign/documentation',
    setAccountNumber = '/sign/accountNumber',
    signCompleted = '/sign/completed',
    insurance = '/insurance',
    error = '/error',
    declined = '/declined',
    declinedFromAgent = '/declinedAgent',
    canceled = '/canceled',
    completed = '/completed',
    applicantActionsCompleted = '/applicantCompleted',
    notFound = '/notfound',
    coSignerWait = '/cosignerwait',
    inProgress = '/inProgress',
    setPin = '/setpin',
    setPinError = '/setPinError',
    loadApplication = '/loadApplication',
    sblCompleted = '/sign/sblCompleted',
    setPinCompleted = '/setPinCompleted',
}

export const navigateToStep = (
    step: ApplicationPaths,
    applicationId: string | undefined,
    navigate: NavigateFunction,
    applicantId: string | null | undefined
) => {
    navigate(getApplicationPath(step, applicationId, applicantId));
};

export function getApplicationPath(step: ApplicationPaths, applicationId: string | undefined, applicantId: string | null | undefined) {
    if (!applicationId) {
        return step;
    }
    const basePath = `${step}?applicationId=${applicationId}`;
    return applicantId ? `${basePath}&applicantId=${applicantId}` : basePath;
}
